import { ReactChild } from 'react';
import styles from './heading.module.css';

interface HeadingProps {
  title: string;
  // eslint-disable-next-line react/require-default-props
  children?: ReactChild;
}

const Heading: React.FC<HeadingProps> = ({ title, children }: HeadingProps) => {
  return (
    <header className={styles.heading}>
      <h1 className={styles.title}>{title}</h1>
      {children}
    </header>
  );
};

export default Heading;
